/* BM SIZE GUIDE — opens the size chart from /pages/barestreep-size-chart in a popup (cart page + cart drawer).
   The chart markup and its styles are fetched from that page's "Custom Liquid" section, so the popup always
   matches the page. Tabs (Body / Product) and units (Inches / CM) work exactly like on the page. */
(function () {
  'use strict';
  if (window.__bmSizeGuideReady) return;
  window.__bmSizeGuideReady = true;

  var cfg = window.BMSizeGuideConfig || {};
  var modal = null, panel = null, body = null, closeBtn = null;
  var loaded = null;      /* Promise for the fetched guide */
  var lastFocus = null;

  function withParam(url, key, val) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + key + '=' + encodeURIComponent(val);
  }

  function extract(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var guide = doc.querySelector('.size-guide');
    if (!guide) return null;
    var scope = guide.closest('.shopify-section') || guide.parentNode || doc.body;
    var styles = Array.prototype.slice.call(scope.querySelectorAll('style'));
    Array.prototype.slice.call(guide.querySelectorAll('script')).forEach(function (s) { s.remove(); });
    return { guide: guide, styles: styles };
  }

  function getText(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
  }

  /* Section Rendering API first (small response); full page as a fallback if the section id ever changes */
  function load(url) {
    if (loaded) return loaded;
    var first = cfg.sectionId ? getText(withParam(url, 'section_id', cfg.sectionId)).then(extract, function () { return null; }) : Promise.resolve(null);
    loaded = first.then(function (res) {
      return res || getText(url).then(extract);
    }).then(function (res) {
      if (!res) throw new Error('Size guide not found');
      return res;
    });
    loaded.catch(function () { loaded = null; });
    return loaded;
  }

  /* Same behaviour as the page script, scoped to one guide so duplicate ids never clash */
  function wire(guide) {
    var tab = 'body', unit = 'inch';
    var tabs = guide.querySelectorAll('.sg-tab');
    var units = guide.querySelectorAll('.sg-unit');
    function sync() {
      Array.prototype.forEach.call(guide.querySelectorAll('.sg-content'), function (el) {
        el.classList.toggle('active', el.id === tab + '-' + unit);
      });
      Array.prototype.forEach.call(guide.querySelectorAll('.sg-instruction'), function (el) {
        el.classList.toggle('active', el.id === 'instruction-' + tab);
      });
      Array.prototype.forEach.call(tabs, function (b) { b.setAttribute('aria-pressed', b.classList.contains('active') ? 'true' : 'false'); });
      Array.prototype.forEach.call(units, function (b) { b.setAttribute('aria-pressed', b.classList.contains('active') ? 'true' : 'false'); });
    }
    function pick(list, btn) {
      Array.prototype.forEach.call(list, function (b) { b.classList.toggle('active', b === btn); });
    }
    var activeTab = guide.querySelector('.sg-tab.active');
    var activeUnit = guide.querySelector('.sg-unit.active');
    if (activeTab && activeTab.dataset.tab) tab = activeTab.dataset.tab;
    if (activeUnit && activeUnit.dataset.unit) unit = activeUnit.dataset.unit;
    Array.prototype.forEach.call(tabs, function (b) {
      b.type = 'button';
      b.addEventListener('click', function () { tab = b.dataset.tab || tab; pick(tabs, b); sync(); });
    });
    Array.prototype.forEach.call(units, function (b) {
      b.type = 'button';
      b.addEventListener('click', function () { unit = b.dataset.unit || unit; pick(units, b); sync(); });
    });
    sync();
  }

  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'bm-sg';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Size guide');
    modal.innerHTML =
      '<div class="bm-sg__backdrop" data-bm-sg-close></div>' +
      '<div class="bm-sg__panel" tabindex="-1">' +
        '<button type="button" class="bm-sg__close" data-bm-sg-close aria-label="Close size guide">&times;</button>' +
        '<div class="bm-sg__body"><p class="bm-sg__status">Loading size guide…</p></div>' +
      '</div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('.bm-sg__panel');
    body = modal.querySelector('.bm-sg__body');
    closeBtn = modal.querySelector('.bm-sg__close');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bm-sg-close]')) { e.preventDefault(); e.stopPropagation(); close(); }
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(panel.querySelectorAll('button, a[href], input, select, [tabindex]:not([tabindex="-1"])'), function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function open(url, trigger) {
    build();
    lastFocus = trigger || document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('bm-sg-lock');
    void modal.offsetWidth; /* commit the hidden→shown state so the fade-in transition runs */
    modal.classList.add('is-open');
    try { closeBtn.focus({ preventScroll: true }); } catch (_) { closeBtn.focus(); }
    if (body.getAttribute('data-ready') === 'true') return;
    load(url).then(function (res) {
      body.innerHTML = '';
      res.styles.forEach(function (s) { body.appendChild(document.importNode(s, true)); });
      var guide = document.importNode(res.guide, true);
      body.appendChild(guide);
      body.setAttribute('data-ready', 'true');
      var title = guide.querySelector('.size-guide__title');
      if (title) { title.id = 'bm-sg-title'; modal.removeAttribute('aria-label'); modal.setAttribute('aria-labelledby', 'bm-sg-title'); }
      wire(guide);
    }).catch(function () {
      /* Could not load — fall back to the page itself */
      window.location.href = url;
    });
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('bm-sg-lock');
    setTimeout(function () { modal.hidden = true; }, 200);
    if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus(); } catch (_) {} }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-bm-size-guide]');
    if (!link) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var url = link.getAttribute('href') || cfg.url;
    if (!url) return;
    e.preventDefault();
    /* Already on the size chart page: just close the drawer and scroll to the chart */
    var onPage = Array.prototype.filter.call(document.querySelectorAll('.size-guide'), function (el) { return !el.closest('.bm-sg'); })[0];
    if (onPage) {
      if (window.BMCart && window.BMCart.close) window.BMCart.close();
      onPage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    open(url, link);
  });

  /* Warm the request on hover / touch so the popup opens with the chart already there */
  function warm(e) {
    var link = e.target.closest && e.target.closest('[data-bm-size-guide]');
    if (link) load(link.getAttribute('href') || cfg.url).catch(function () {});
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);

  window.BMSizeGuide = { open: function (url) { open(url || cfg.url); }, close: close };
})();
